import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Tag } from 'antd';
import React, { FC, useCallback } from 'react';

export const TIME_IN = {
	HOURS: 'Hours',
	MINUTES: 'Minutes',
};

const LaborTimeSelect: FC<any> = ({ value = TIME_IN.HOURS, onChange }) => {
	const onSelect = useCallback((val) => () => onChange(val), [onChange]);

	const timeOptions = (
		<Menu>
			<Menu.Item onClick={onSelect(TIME_IN.HOURS)}>{TIME_IN.HOURS}</Menu.Item>
			<Menu.Item onClick={onSelect(TIME_IN.MINUTES)}>{TIME_IN.MINUTES}</Menu.Item>
		</Menu>
	);

	return (
		<div className="no-wrap flex flex-row items-center">
			<div>Time</div>
			<div className="ml-2">
				<Dropdown overlay={timeOptions}>
					<Tag>
						{value} <DownOutlined />
					</Tag>
				</Dropdown>
			</div>
		</div>
	);
};

export default LaborTimeSelect;
